module.exports = __webpack_public_path__ + "img/ico-print.62fedef1.svg";